<template>
  <div class="nav">
    <div class="title-box">
      <div class="grid-content">
        <router-link :to="'/'">
          <img src="../../../assets/images/logo.png" style="margin-top: 24px"/>
        </router-link>
      </div>
      <div class="logo-title">
        <p class="logo-p">连锁加盟标准化</p>
        <p> 营销服务提供商</p>
      </div>
      <div class="menu">
        <div class="menu-title menu">
          <router-link :to="'/'">首页</router-link>
        </div>
        <div class="menu-title">
          <router-link :to="'/advantage'">优势</router-link>
        </div>
        <div class="menu-title">
          <router-link :to="'/products'">产品</router-link>
        </div>
        <div class="menu-title">
          <router-link :to="'/successful-case'">成功案例</router-link>
        </div>
        <div class="menu-title">
          <router-link :to="'/learning-and-support'">学习与支持</router-link>
        </div>
        <div class="menu-title">
          <router-link :to="'/about-us'">关于我们</router-link>
        </div>
        <div class="menu-title">
          <router-link :to="'/join-us'">招聘</router-link>
        </div>
        <div class="menu-title" v-if="isLogin">
          <router-link :to="'/login'" style="text-decoration: none;color: white">
            <el-button type="primary" style="background: #085ECC">登录</el-button>
          </router-link>
        </div>
        <div class="menu-title" v-else>
          <router-link :to="'/work-bench'" style="text-decoration: none;color: white">
            <el-button type="primary" style="background: #085ECC">返回工作台</el-button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ms-nav',
    computed: {
      isLogin () {
        let info = this.$store.state.user.info
        return info === null
      }
    },
    data () {
      return {}
    }
  }
</script>

<style scoped="scoped" lang="scss">
  .nav {
    .title-box {
      width: 1200px;
      height: 102px;
      line-height: 102px;
      margin: 0 auto;
      .grid-content {
        float: left;
      }
      .logo-title {
        height: 32px;
        padding: 1px 0 0 25px;
        box-sizing: border-box;
        margin: 35px 0 0 25px;
        border-left: 2px solid #666;
        float: left;
        > p {
          font-size: 14px;
          color: #5d5d5d;
          line-height: 8px;
          margin-top: 0px;
        }
      }
      .menu {
        padding-left: 40px;
        box-sizing: border-box;
        .menu-title {
          position: relative;
          float: left;
          margin: 0 20px;
          &:hover {
            cursor: pointer;
          }
          .router-link-exact-active {
            color: #085ECC;
          }
          a {
            text-decoration: none;
            display: block;
            text-align: center;
            color: #333;
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/tourist/common/Nav.vue